import { useFormContext } from '@calendly/form'
import { useOnValueChange } from '@calendly/hooks'

export const ResetFormOnSave = ({ isSaved }) => {
  const { values, resetForm } = useFormContext()

  useOnValueChange(isSaved, () => {
    if (isSaved) resetForm({ values })
  })

  return null
}
